/* VESPER theme JS — progressive enhancement */
(function () {
  "use strict";

  function $(s, c) { return (c || document).querySelector(s); }
  function $all(s, c) { return Array.from((c || document).querySelectorAll(s)); }

  // Reveal on scroll
  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("is-visible"); io.unobserve(e.target); }
      });
    }, { threshold: 0.08, rootMargin: "0px 0px -8% 0px" });
    $all(".reveal").forEach(function (el) { io.observe(el); });
    // fallback
    setTimeout(function () { $all(".reveal:not(.is-visible)").forEach(function (el) { el.classList.add("is-visible"); }); }, 1400);
  } else {
    $all(".reveal").forEach(function (el) { el.classList.add("is-visible"); });
  }

  // Mobile menu
  var toggle = $(".menu-toggle");
  var menu = $(".mobile-menu");
  if (toggle && menu) {
    toggle.addEventListener("click", function () { menu.classList.toggle("is-open"); document.body.style.overflow = menu.classList.contains("is-open") ? "hidden" : ""; });
    $all("a", menu).forEach(function (a) { a.addEventListener("click", function () { menu.classList.remove("is-open"); document.body.style.overflow = ""; }); });
  }

  // Accordion
  $all(".accordion").forEach(function (acc) {
    $all(".accordion__btn", acc).forEach(function (btn) {
      btn.addEventListener("click", function () {
        var item = btn.parentElement;
        var panel = $(".accordion__panel", item);
        var open = item.classList.contains("is-open");
        $all(".accordion__item", acc).forEach(function (it) { it.classList.remove("is-open"); $(".accordion__panel", it).style.maxHeight = null; });
        if (!open) { item.classList.add("is-open"); panel.style.maxHeight = panel.scrollHeight + "px"; }
      });
    });
  });

  // Product gallery thumbnails
  var mainImg = $(".product__main-img img");
  if (mainImg) {
    $all(".product__thumb").forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        var src = thumb.getAttribute("data-src");
        if (src) mainImg.src = src;
        $all(".product__thumb").forEach(function (t) { t.classList.remove("is-active"); });
        thumb.classList.add("is-active");
      });
    });
  }

  // Sticky ATC (product page)
  var stickyBar = $(".sticky-atc");
  var atcBtn = $("[data-sticky-trigger]");
  if (stickyBar && atcBtn && "IntersectionObserver" in window) {
    var sio = new IntersectionObserver(function (entries) {
      stickyBar.classList.toggle("is-visible", !entries[0].isIntersecting);
    }, { threshold: 0 });
    sio.observe(atcBtn);
  }

  // Variant change updates price (simple themes rely on Shopify option_selection; here we just keep native select)
  // Update cart count on add (best-effort, Shopify redirects by default)
})();
